import React, { useState, useEffect } from "react";
import "./CloudIndustry.css";
import case1 from "../../marketplace/marketplaceassets/case1.png";
import case2 from "../../marketplace/marketplaceassets/case2.png";
import case3 from "../../marketplace/marketplaceassets/case3.png";
import case4 from "../../marketplace/marketplaceassets/case4.png";
import case5 from "../../marketplace/marketplaceassets/case5.png";
import case6 from "../../marketplace/marketplaceassets/case6.png";

export default function CloudIndustry() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const cases = [
    { img: case1, name: "Retail & E-Commerce" },
    { img: case2, name: "Real Estate" },
    { img: case3, name: "Healthcare" },
    { img: case4, name: "FinTech & BFSI" },
    { img: case5, name: "SaaS & IT" },
    { img: case6, name: "Games" },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setCardsToShow(3);
      } else {
        setCardsToShow(2);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="cloud-industry" className="cloudmainclass">
      <h2 className="heading">Leading Use Cases for Metaverse Development</h2>
      <p className="subheading">
        Exploring Real-World Applications Shaping the Future of Virtual Worlds
      </p>

     <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(-${(100 / cardsToShow) * currentSlide}%)`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 20) / cardsToShow
                  }px)`,
                }}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="carousel-dots">
          {cases.map((_, index) => (
            <button
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
